("use strict");
import { calculateCoolerEnthalpy } from "../pages/molier_diagram/airProcesses/processCalculations";
import constants from "./constants";
import { getCustomSummerData } from "./services/projectService";
import {
  //calculatePD,
  calculateCoolerAbsHumidity,
} from "../../src/pages/molier_diagram/airProcesses/processCalculations";

export function calcutationFunctions(dryBulbTemp, wetBulbTemp) {
  console.log(dryBulbTemp + " i " + wetBulbTemp);
  if ((dryBulbTemp || wetBulbTemp) === undefined)
    return { RelativeHumidity: 0, DewPointTemperatureCelsius: 0 };

  let DryBulbTemperatureCelsius = +dryBulbTemp;
  let WetBulbTemperatureCelsius = +wetBulbTemp;

  let DryBulbTemperatureKelvin = +dryBulbTemp + constants.Kelvin;
  let WetBulbTemperatureKelvin = +wetBulbTemp + constants.Kelvin;

  let WaterVaporSaturationPressure = Math.round(
    Math.exp(
      constants.C1 / DryBulbTemperatureKelvin +
        constants.C2 +
        constants.C3 * DryBulbTemperatureKelvin +
        constants.C4 * (DryBulbTemperatureKelvin * DryBulbTemperatureKelvin) +
        constants.C5 *
          (DryBulbTemperatureKelvin *
            DryBulbTemperatureKelvin *
            DryBulbTemperatureKelvin) +
        constants.C6 *
          (DryBulbTemperatureKelvin *
            DryBulbTemperatureKelvin *
            DryBulbTemperatureKelvin *
            DryBulbTemperatureKelvin) +
        constants.C7 * Math.log(DryBulbTemperatureKelvin)
    )
  );

  console.log(WaterVaporSaturationPressure);

  let WaterVaporSaturationPressurePwsh = Math.round(
    Math.exp(
      constants.C1 / WetBulbTemperatureKelvin +
        constants.C2 +
        constants.C3 * WetBulbTemperatureKelvin +
        constants.C4 * (WetBulbTemperatureKelvin * WetBulbTemperatureKelvin) +
        constants.C5 *
          (WetBulbTemperatureKelvin *
            WetBulbTemperatureKelvin *
            WetBulbTemperatureKelvin) +
        constants.C6 *
          (WetBulbTemperatureKelvin *
            WetBulbTemperatureKelvin *
            WetBulbTemperatureKelvin *
            WetBulbTemperatureKelvin) +
        constants.C7 * Math.log(WetBulbTemperatureKelvin)
    )
  );
  console.log(WaterVaporSaturationPressurePwsh);

  let HumidityRatio =
    (((2501 - 2.381 * WetBulbTemperatureCelsius) *
      constants.Mm *
      WaterVaporSaturationPressurePwsh) /
      (constants.Patm * 1000 - WaterVaporSaturationPressurePwsh) -
      (DryBulbTemperatureCelsius - WetBulbTemperatureCelsius)) /
    (2501 +
      1.805 * DryBulbTemperatureCelsius -
      4.186 * WetBulbTemperatureCelsius);
  console.log(HumidityRatio);

  let HumidityRatioWs =
    (constants.Mm * WaterVaporSaturationPressure) /
    (constants.Patm * 1000 - WaterVaporSaturationPressure);
  console.log(HumidityRatioWs);

  let RelativeHumidity = Math.round(
    (100 * HumidityRatio) /
      HumidityRatioWs /
      (1 -
        (1 - HumidityRatio / HumidityRatioWs) *
          (WaterVaporSaturationPressure / (constants.Patm * 1000)))
  );
  console.log(RelativeHumidity);

  let WaterVaporPartialPressure = Math.round(
    (1000 * constants.Patm * HumidityRatio) / (constants.Mm + HumidityRatio)
  );
  console.log(WaterVaporPartialPressure);

  let waterVaporValue = WaterVaporPartialPressure / 1000.0;
  console.log(waterVaporValue);

  let DewPointTemperatureCelsius =
    Math.round(
      (constants.C8 +
        constants.C9 * Math.log(waterVaporValue) +
        constants.C10 * Math.pow(Math.log(waterVaporValue), 2) +
        constants.C11 * Math.pow(Math.log(waterVaporValue), 3) +
        constants.C12 * Math.pow(waterVaporValue, 0.1984)) *
        10
    ) / 10;

  console.log(DewPointTemperatureCelsius);
  //MidpointRounding.AwayFromZero
  let userInputSummer = {
    summerTemp: DryBulbTemperatureCelsius,
    summerWB: WetBulbTemperatureCelsius,
  };

  //Testiranje sa vrednostima koje vraca bek
  getCustomSummerData(userInputSummer)
    .then((response) => {
      if (response.statusCode >= 200 && response.statusCode < 300) {
        //alert("OK!");
      }
    })
    .catch((err) => {
      alert("err");
    });
  let wetBulbLimit;
  if (RelativeHumidity < 0) {
    RelativeHumidity = 0;
    //DryBulbTemperatureCelsius = 56; // findMinTemperatureForRH0(wetBulbTemp); // Set minimum temperature value here
    wetBulbLimit = calculateMINWetBulbTemperature(+dryBulbTemp);
  } else if (RelativeHumidity > 100) {
    RelativeHumidity = 100;
    // DryBulbTemperatureCelsius = findMaxTemperatureForRH100(wetBulbTemp); // Set maximum temperature value here
    wetBulbLimit = calculateMAXWetBulbTemperature(+dryBulbTemp);
  }

  console.log(RelativeHumidity, wetBulbLimit, dryBulbTemp);

  return { RelativeHumidity, DewPointTemperatureCelsius };

  //HumidityRatio = 0.6222 * RelativeHumidity * pd / (AirPressure - RelativeHumidity * pd / 1000) -----> druga formula
}

export function calcutationFunctionsWithHumidity(
  dryBulbTemp,
  wetBulbTemp,
  relativeHumidity
) {
  if ((dryBulbTemp || wetBulbTemp) === undefined)
    return { RelativeHumidity: 0, DewPointTemperatureCelsius: 0 };

  let DryBulbTemperatureCelsius = +dryBulbTemp;
  let WetBulbTemperatureCelsius = +wetBulbTemp;

  let DryBulbTemperatureKelvin = +dryBulbTemp + constants.Kelvin;
  let WetBulbTemperatureKelvin = +wetBulbTemp + constants.Kelvin;

  let WaterVaporSaturationPressure = Math.round(
    Math.exp(
      constants.C1 / DryBulbTemperatureKelvin +
        constants.C2 +
        constants.C3 * DryBulbTemperatureKelvin +
        constants.C4 * (DryBulbTemperatureKelvin * DryBulbTemperatureKelvin) +
        constants.C5 *
          (DryBulbTemperatureKelvin *
            DryBulbTemperatureKelvin *
            DryBulbTemperatureKelvin) +
        constants.C6 *
          (DryBulbTemperatureKelvin *
            DryBulbTemperatureKelvin *
            DryBulbTemperatureKelvin *
            DryBulbTemperatureKelvin) +
        constants.C7 * Math.log(DryBulbTemperatureKelvin)
    )
  );

  // console.log(WaterVaporPartialPressure);

  let WaterVaporSaturationPressurePwsh = Math.round(
    Math.exp(
      constants.C1 / WetBulbTemperatureKelvin +
        constants.C2 +
        constants.C3 * WetBulbTemperatureKelvin +
        constants.C4 * (WetBulbTemperatureKelvin * WetBulbTemperatureKelvin) +
        constants.C5 *
          (WetBulbTemperatureKelvin *
            WetBulbTemperatureKelvin *
            WetBulbTemperatureKelvin) +
        constants.C6 *
          (WetBulbTemperatureKelvin *
            WetBulbTemperatureKelvin *
            WetBulbTemperatureKelvin *
            WetBulbTemperatureKelvin) +
        constants.C7 * Math.log(WetBulbTemperatureKelvin)
    )
  );
  console.log(WaterVaporSaturationPressurePwsh);

  let HumidityRatio =
    (((2501 - 2.381 * WetBulbTemperatureCelsius) *
      constants.Mm *
      WaterVaporSaturationPressurePwsh) /
      (constants.Patm * 1000 - WaterVaporSaturationPressurePwsh) -
      (DryBulbTemperatureCelsius - WetBulbTemperatureCelsius)) /
    (2501 +
      1.805 * DryBulbTemperatureCelsius -
      4.186 * WetBulbTemperatureCelsius);
  console.log(HumidityRatio);

  let HumidityRatioWs =
    (constants.Mm * WaterVaporSaturationPressure) /
    (constants.Patm * 1000 - WaterVaporSaturationPressure);
  console.log(HumidityRatioWs);

  let RelativeHumidity = Math.round(
    (100 * HumidityRatio) /
      HumidityRatioWs /
      (1 -
        (1 - HumidityRatio / HumidityRatioWs) *
          (WaterVaporSaturationPressure / (constants.Patm * 1000)))
  );
  console.log(RelativeHumidity);

  let WaterVaporPartialPressure = Math.round(
    (1000 * constants.Patm * HumidityRatio) / (constants.Mm + HumidityRatio)
  );
  console.log(WaterVaporPartialPressure);

  let waterVaporValue = WaterVaporPartialPressure / 1000.0;
  console.log(waterVaporValue);

  let DewPointTemperatureCelsius =
    Math.round(
      (constants.C8 +
        constants.C9 * Math.log(waterVaporValue) +
        constants.C10 * Math.pow(Math.log(waterVaporValue), 2) +
        constants.C11 * Math.pow(Math.log(waterVaporValue), 3) +
        constants.C12 * Math.pow(waterVaporValue, 0.1984)) *
        10
    ) / 10;

  console.log(DewPointTemperatureCelsius);
  //MidpointRounding.AwayFromZero
  let userInputSummer = {
    summerTemp: DryBulbTemperatureCelsius,
    summerWB: WetBulbTemperatureCelsius,
  };

  //Testiranje sa vrednostima koje vraca bek
  getCustomSummerData(userInputSummer)
    .then((response) => {
      if (response.statusCode >= 200 && response.statusCode < 300) {
        //alert("OK!");
      }
    })
    .catch((err) => {
      alert("err");
    });
  let wetBulbLimit;
  if (RelativeHumidity < 0) {
    RelativeHumidity = 0;
    //DryBulbTemperatureCelsius = 56; // findMinTemperatureForRH0(wetBulbTemp); // Set minimum temperature value here
    wetBulbLimit = calculateMINWetBulbTemperature(+dryBulbTemp);
  } else if (RelativeHumidity > 100) {
    RelativeHumidity = 100;
    // DryBulbTemperatureCelsius = findMaxTemperatureForRH100(wetBulbTemp); // Set maximum temperature value here
    wetBulbLimit = calculateMAXWetBulbTemperature(+dryBulbTemp);
  }

  console.log(RelativeHumidity, wetBulbLimit, dryBulbTemp);

  return { RelativeHumidity, DewPointTemperatureCelsius };

  //HumidityRatio = 0.6222 * RelativeHumidity * pd / (AirPressure - RelativeHumidity * pd / 1000) -----> druga formula
}

function findMinTemperatureForRH0(wetBulbTemp) {
  let minTemperature = -89; // Initial minimum temperature value
  let maxTemperature = 56.7; // Initial maximum temperature value
  const targetRH = 0; // Target relative humidity

  while (maxTemperature - minTemperature > 0.01) {
    const midTemperature = (minTemperature + maxTemperature) / 2;
    const calculatedRH = calcutationFunctions(midTemperature, wetBulbTemp);

    if (calculatedRH > targetRH) {
      maxTemperature = midTemperature;
    } else {
      minTemperature = midTemperature;
    }
  }
  console.log("Min" + minTemperature);

  return minTemperature;
}
function findMaxTemperatureForRH100(wetBulbTemp) {
  let minTemperature = -89; // Initial minimum temperature value
  let maxTemperature = 56.7; // Initial maximum temperature value
  const targetRH = 100; // Target relative humidity
  let minBulbTemperatureKelvin = +minTemperature + constants.Kelvin;
  let MaxBulbTemperatureKelvin = +maxTemperature + constants.Kelvin;
  let WetBulbTemperatureKelvin = +wetBulbTemp + constants.Kelvin;

  while (maxTemperature - minTemperature > 0.01) {
    const midTemperature =
      (minBulbTemperatureKelvin + MaxBulbTemperatureKelvin) / 2;
    let calculatedRH;
    let WaterVaporSaturationPressure = Math.round(
      Math.exp(
        constants.C1 / midTemperature +
          constants.C2 +
          constants.C3 * midTemperature +
          constants.C4 * (midTemperature * midTemperature) +
          constants.C5 * (midTemperature * midTemperature * midTemperature) +
          constants.C6 *
            (midTemperature *
              midTemperature *
              midTemperature *
              midTemperature) +
          constants.C7 * Math.log(midTemperature)
      )
    );

    let WaterVaporSaturationPressurePwsh = Math.round(
      Math.exp(
        constants.C1 / WetBulbTemperatureKelvin +
          constants.C2 +
          constants.C3 * WetBulbTemperatureKelvin +
          constants.C4 * (WetBulbTemperatureKelvin * WetBulbTemperatureKelvin) +
          constants.C5 *
            (WetBulbTemperatureKelvin *
              WetBulbTemperatureKelvin *
              WetBulbTemperatureKelvin) +
          constants.C6 *
            (WetBulbTemperatureKelvin *
              WetBulbTemperatureKelvin *
              WetBulbTemperatureKelvin *
              WetBulbTemperatureKelvin) +
          constants.C7 * Math.log(WetBulbTemperatureKelvin)
      )
    );

    let HumidityRatio =
      (((2501 - 2.381 * wetBulbTemp) *
        constants.Mm *
        WaterVaporSaturationPressurePwsh) /
        (constants.Patm * 1000 - WaterVaporSaturationPressurePwsh) -
        (midTemperature - wetBulbTemp)) /
      (2501 + 1.805 * minTemperature - 4.186 * wetBulbTemp);

    let HumidityRatioWs =
      (constants.Mm * WaterVaporSaturationPressure) /
      (constants.Patm * 1000 - WaterVaporSaturationPressure);

    calculatedRH = Math.round(
      (100 * HumidityRatio) /
        HumidityRatioWs /
        (1 -
          (1 - HumidityRatio / HumidityRatioWs) *
            (WaterVaporSaturationPressure / (constants.Patm * 1000)))
    );

    let WaterVaporPartialPressure = Math.round(
      (1000 * constants.Patm * HumidityRatio) / (constants.Mm + HumidityRatio)
    );

    let waterVaporValue = WaterVaporPartialPressure / 1000.0;

    let DewPointTemperatureCelsius =
      Math.round(
        (constants.C8 +
          constants.C9 * Math.log(waterVaporValue) +
          constants.C10 * Math.pow(Math.log(waterVaporValue), 2) +
          constants.C11 * Math.pow(Math.log(waterVaporValue), 3) +
          constants.C12 * Math.pow(waterVaporValue, 0.1984)) *
          10
      ) / 10;
    //MidpointRounding.AwayFromZero

    if (calculatedRH < targetRH) {
      minTemperature = midTemperature;
    } else {
      maxTemperature = midTemperature;
    }
  }
  console.log("Maxn" + maxTemperature);

  return maxTemperature;
}

function calculateMAXWetBulbTemperature(dryBulbTemperature) {
  console.log("CAO MAX");
  const T = dryBulbTemperature;
  const RH = 100;

  const A = 17.27;
  const B = 237.7;

  const alpha = (A * T) / (B + T) + Math.log(RH / 100.0);
  const wetBulbTemperature = (B * alpha) / (A - alpha);

  return wetBulbTemperature;
}
function calculateMINWetBulbTemperature(dryBulbTemperature) {
  console.log("CAO MIN");
  const T = dryBulbTemperature;
  const RH = 0.000000001;

  const A = 17.27;
  const B = 237.7;

  const alpha = (A * T) / (B + T) + Math.log(RH / 100.0);
  console.log("ALPHA" + alpha);
  const wetBulbTemperature = (B * alpha) / (A - alpha);
  console.log("WB" + wetBulbTemperature);

  return wetBulbTemperature;
}

//!!!!!!!!!!  MOLIJER KALKULACIJEEEEEEE !!!!!!!!!!!!!!!!!!!!!!!!!!!!
//Sve kalkulacije su preuzete iz Excel-a koji je pripremila firma C.I.C. Jan Hřebec iz Češke.

//Funkcija za racunanje Pressure drop-a
//TO DO obrada undefined povratne vrednosti u funckijama gde se poziva
export const calculatePD = (temperature) => {
  let pd;
  if (temperature < -50) return undefined;
  else if (temperature >= -50 && temperature < 0)
    return Math.exp((1738.4 + 28.74 * temperature) / (271 + temperature));
  else if (temperature >= 0 && temperature <= 100)
    return Math.exp((1500.3 + 23.5 * temperature) / (234 + temperature));
  else return undefined;
};

//Funkcija za racunanje vazdusnog pritiska
export const calculateAirPressure = (elevation) => {
  return Math.round(
    constants.PressureAtSeaLevel *
      Math.exp(
        (-constants.GravityAcceleration * elevation * constants.MolarMass) /
          (constants.SeaLevelTemperature * constants.UniversalGas)
      )
  );
};

//Funkcija za racunanje gustine vazduha - vraca rezultat zaokruzen na 3 decimale
export const calculateAirDensity = (
  airPressure,
  temperatureDryBulb,
  absoluteHumidity
) => {
  return (
    Math.round(
      ((airPressure * (absoluteHumidity / 1000 + 1)) /
        461.39 /
        (273.15 + temperatureDryBulb) /
        (absoluteHumidity / 1000 + 0.6222)) *
        1e3
    ) / 1e3
  );
};

//Funkcija za racunanje masenog pritiska? - vraca rezultat zaokruzen na 3 decimale
export const calculateMassFlow = (airFlowHours) => {
  return Math.round((+airFlowHours / 3600) * 1.2 * 1e3) / 1e3;
};
//Funkcija za racunanje stvarnog protoka vazduha -
export const calculateRealFlow = (massFlow, airDensity, absoluteHumidity) => {
  return Math.round(
    ((+massFlow * 3600) / airDensity) * (1 + absoluteHumidity / 1000)
  );
};
//Funkcija za racunanje normalnog protoka vazduha - jednaka je vrednosti koju komora izbacuje ako airflow
export const calculateNormalFlow = (massFlow) => {
  return Math.round((massFlow * 3600) / 1.2);
};

//Funkcija za racunanje apsolutne vlaznosti vazduha na osnovu temperature i relativne vlaznosti vazduha
//Funkcija se koristi za sve tacke osim procesa mesanja
export const calculateAbsHumidityFromTempAndRelative = (
  temperature,
  humidity,
  elevation
) => {
  let relHum = humidity / 100;

  const airPressure = calculateAirPressure(elevation);

  //temp -50 do
  let pd;
  if (temperature < 0)
    pd = Math.exp((1738.4 + 28.74 * temperature) / (271 + temperature));
  else if (temperature <= 100)
    pd = Math.exp((1500.3 + 23.5 * temperature) / (234 + temperature));
  else pd = 0;

  let x = ((0.6222 * relHum * pd) / (airPressure - relHum * pd)) * 1000;

  return Math.round(x * 10) / 10;
};

//Racunanje apsolutne vlaznosti za proces mesanja
//Koristi se apsolutna vlaznost i maseni protok za prethodne dve tacke
export const calculateAbsoluteHumidityMixing = (prevPoint, secondPrevPoint) => {
  return (
    Math.round(
      ((prevPoint.absoluteHumidity * prevPoint.massFlow +
        secondPrevPoint.absoluteHumidity * secondPrevPoint.massFlow) /
        (prevPoint.massFlow + secondPrevPoint.massFlow)) *
        10
    ) / 10
  );
};

//Funkcija za racunanje entalpije na osnovu temp. suvog termomentra i apsolutne vlaznosti
//Koristi se za sve procese sem procesa mesanja
export const calculateEnthalpy = (temperatureDryBulb, absoluteHumidity) => {
  return (
    Math.round(
      (1.01 * temperatureDryBulb +
        ((2501 + 1.86 * temperatureDryBulb) * absoluteHumidity) / 1000) *
        10
    ) / 10 //rezultat se zaokruzuje na dve decimale
  );
};

//Racunanje entalpije za proces mesanja
//Koriste se entalpija i maseni protok iz prethodne dve tacke
export const calculateEnthalpyMixing = (prevPoint, secondPrevPoint) => {
  return (
    Math.round(
      ((prevPoint.enthalpy * prevPoint.massFlow +
        secondPrevPoint.enthalpy * secondPrevPoint.massFlow) /
        (prevPoint.massFlow + secondPrevPoint.massFlow)) *
        10
    ) / 10 //rezultat se zaokruzuje na dve decimale
  );
};

//Funkcija za racunanje temperature vlaznog termometra na osnovu temperature suvog i relativne vlaznosti
export const calculateWetBulbTemperature = (
  temperatureDryBulb,
  relativeHumidity
) => {
  const temperatureDryBulb1 =
    temperatureDryBulb !== "" && temperatureDryBulb !== "-"
      ? parseFloat(temperatureDryBulb)
      : 0;
  const relativeHumidity1 =
    relativeHumidity !== "" && relativeHumidity !== "-"
      ? parseFloat(relativeHumidity)
      : 0;

  return (
    Math.round(
      (temperatureDryBulb1 *
        Math.atan(0.151977 * Math.pow(relativeHumidity1 + 8.313659, 0.5)) +
        0.00391838 *
          Math.pow(relativeHumidity1, 3 / 2) *
          Math.atan(0.023101 * relativeHumidity1) -
        Math.atan(relativeHumidity1 - 1.676331) +
        Math.atan(temperatureDryBulb1 + relativeHumidity1) -
        4.686035) *
        100
    ) / 100
  );
};

//Funkcija za racunanje predate kolicine toplote - na osnovu entalpije trenutne i prethodne tacke
export const calculateUsedPower = (
  massFlow,
  currentEnthalpy,
  previousEnthalpy
) => {
  return (
    Math.round(massFlow * (currentEnthalpy - previousEnthalpy) * 1e2) / 1e2
  ); //zaokruzena na dve decimale
};

//Funkcija za predate kolicine vode - na osnovu apsolutne vlaznosti trenutne i prethodne tacke
export const calculateUsedWater = (
  massFlow,
  currentAbsoluteHumidity,
  previousAbsoluteHumidity
) => {
  return (
    Math.round(
      massFlow *
        (currentAbsoluteHumidity - previousAbsoluteHumidity) *
        3.6 *
        1e2
    ) / 1e2
  ); //zaokruzena na dve decimale
};

//Funkcija za predate kolicine vode - na osnovu apsolutne vlaznosti trenutne i prethodne 2 tacke
export const calculateUsedWaterMixing = (
  currentMassFlow,
  currentAbsoluteHumidity,
  previousMassFlow,
  previousAbsoluteHumidity,
  secondPreviousMassFlow,
  secondPreviousAbsoluteHumidity
) => {
  return (
    Math.round(
      (currentMassFlow * currentAbsoluteHumidity -
        previousMassFlow * previousAbsoluteHumidity -
        secondPreviousMassFlow * secondPreviousAbsoluteHumidity) *
        3.6 *
        10
    ) / 10
  ); //zaokruzena na dve decimale
};

//Funkcija za racunanje parametara za tacke koje predstavljaju spoljnu i unutrasnju temperaturu
export const calculateTableData = (
  temperatureDryBulb,
  temperatureWetBulb,
  temperatureDewPoint,
  relativeHumidity,
  elevation,
  airFlowHours
) => {
  const airPressure = calculateAirPressure(elevation);

  const absoluteHumidity = calculateAbsHumidityFromTempAndRelative(
    temperatureDryBulb,
    relativeHumidity,
    elevation
  );
  const temperatureWetBulbCalculated = calculateWetBulbTemperature(
    temperatureDryBulb,
    relativeHumidity
  );
  const enthalpy = calculateEnthalpy(temperatureDryBulb, absoluteHumidity);
  const massFlow = calculateMassFlow(airFlowHours);
  const airDensity = calculateAirDensity(
    airPressure,
    temperatureDryBulb,
    absoluteHumidity
  );
  const realFlow = calculateRealFlow(massFlow, airDensity, absoluteHumidity);

  return {
    temperatureWetBulbCalculated,
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
  };
};

//Funkcija za racunanje parametara za tacku grejanja
export const calculateTableDataForHeating = (
  newTemperature,
  elevation,
  prevPoint
) => {
  const airPressure = calculateAirPressure(elevation);
  //Kod grejanja se ne racuna apsolutna vlaznost vec ostaje ista kao u procesu koji je prethodio
  const absoluteHumidity = prevPoint.absoluteHumidity;

  const enthalpy = calculateEnthalpy(newTemperature, absoluteHumidity);
  //Maseni pritisak se prepisuje iz prethodne tacke
  const massFlow = prevPoint.massFlow;
  const airDensity = calculateAirDensity(
    airPressure,
    +newTemperature,
    absoluteHumidity
  );

  const realFlow = calculateRealFlow(massFlow, airDensity, absoluteHumidity);

  const usedPower = calculateUsedPower(massFlow, enthalpy, prevPoint.enthalpy);

  const usedWater = calculateUsedWater(
    massFlow,
    absoluteHumidity,
    prevPoint.absoluteHumidity
  );
  // const pd = calculatePD(+newTemperature);

  const relativeHumidity = Math.round(
    (((airPressure / 1000 / calculatePD(+newTemperature)) * 1000) /
      ((0.6222 / absoluteHumidity) * 1000 + 1)) *
      100
  );
  const temperatureWetBulbCalculated = calculateWetBulbTemperature(
    +newTemperature,
    relativeHumidity
  );

  return {
    temperatureWetBulbCalculated,
    absoluteHumidity,
    relativeHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    usedPower,
    usedWater,
  };
};

//Funkcije za racunanje parametara za tacku hladjenja
export const calculateTableDataForCooling = (
  coolingTemperature,
  P,
  airFlowHours,
  airFlowSeconds,
  coolerTemperature,
  elevation,
  maxHumidityInProcess,
  prevPoint
) => {
  const coolerAbsoluteHumidity = calculateCoolerAbsHumidity(
    coolerTemperature,
    elevation
  );
  const coolerEnthaply = calculateCoolerEnthalpy(coolerTemperature, elevation);
  let absoluteHumidity;

  //Formule iz Excel dela [Znamo t,h]

  let limitPDperTemperature = calculatePD(+coolingTemperature);
  console.log(" limitPDperTemperature" + limitPDperTemperature);

  let limitAbsHumidityPerTemperature =
    (0.6222 * (maxHumidityInProcess / 100) * limitPDperTemperature) /
    (calculateAirPressure(elevation) / 1000 -
      ((maxHumidityInProcess / 100) * limitPDperTemperature) / 1000);
  console.log(
    " limitAbsHumidityPerTemperature" + limitAbsHumidityPerTemperature
  );
  //Racunamo x na osnovu entalpije

  //Iz formula za hladjenje
  let lastEthaply;
  //Slucaj da je uneta kolicina predate kolicine toplote (utrosena snaga) P u kW
  let massFlow;
  if (airFlowHours !== null || airFlowSeconds !== null) {
    massFlow = calculateMassFlow(airFlowHours, null);
  } else {
    console.log(prevPoint);
    //if (processType !== processTypes.mix)
    massFlow = prevPoint.massFlow;
    //else if (processType === processTypes.mix)
    //massFlow = massFlowFromPrevious + massFlowFromSecondPrevious
    //else
    //massFlow = undefined}
  }
  console.log("mass flow" + massFlow);

  //let massFlowFromPrevious;
  //PROVERITI POSTO SE SAD MENJA STANJE STANJU
  if (airFlowHours !== null || airFlowSeconds !== null) {
    if (airFlowHours !== null) prevPoint.massFlow = (airFlowHours / 3600) * 1.2;
    else if (airFlowSeconds !== null) prevPoint.massFlow = airFlowSeconds * 1.2;
    else prevPoint.massFlow = 0;
  }
  const calculateEnthalpyCooling = () => {
    if (P !== null)
      return (
        Math.round((prevPoint.enthalpy - Math.abs(P / massFlow)) * 1e2) / 1e2
      );
    else if (coolerAbsoluteHumidity < prevPoint.absoluteHumidity)
      return (
        Math.round(
          (prevPoint.enthalpy -
            ((prevPoint.enthalpy - coolerEnthaply) *
              (+coolingTemperature - prevPoint.temperatureDryBulb)) /
              (coolerTemperature - prevPoint.temperatureDryBulb)) *
            1e2
        ) / 1e2
      );
    else return undefined;
  };

  const enthalpy = calculateEnthalpyCooling();

  if (P !== null) lastEthaply = prevPoint.enthalpy - Math.abs(P / massFlow);
  else {
    if (coolerAbsoluteHumidity < prevPoint.absoluteHumidity)
      lastEthaply =
        prevPoint.enthalpy -
        ((prevPoint.enthalpy - coolerEnthaply) *
          (coolingTemperature - prevPoint.temperatureDryBulb)) /
          (coolerTemperature - prevPoint.temperatureDryBulb);
    else lastEthaply = "1";
  }

  let absHumidityPerEnthalpy =
    ((lastEthaply - 1.01 * coolingTemperature) /
      (2501 + 1.86 * coolingTemperature)) *
    1000;

  //Za apsolutnu vlaznost ako je unet P koriste se formule iz Excel dela [Znamo h,x]
  const calculateAbsoluteHumidityPower = () => {
    if (coolerAbsoluteHumidity >= prevPoint.absoluteHumidity)
      return prevPoint.absoluteHumidity;
    else {
      return (
        Math.round(
          (prevPoint.absoluteHumidity +
            ((coolerAbsoluteHumidity - prevPoint.absoluteHumidity) *
              (prevPoint.enthalpy - enthalpy)) /
              (prevPoint.enthalpy - coolerEnthaply)) *
            1e2
        ) / 1e2
      );
    }
  };

  if (P === null) {
    if (absHumidityPerEnthalpy < limitAbsHumidityPerTemperature)
      absoluteHumidity = Math.round(absHumidityPerEnthalpy * 1e2) / 1e2;
    else
      absoluteHumidity = Math.round(limitAbsHumidityPerTemperature * 1e2) / 1e2;
  } else {
    absoluteHumidity = calculateAbsoluteHumidityPower();
  }

  const airPressure = calculateAirPressure(elevation);
  console.log(airPressure);
  //const absoluteHumidity = prevPoint.absoluteHumidity;
  //ENTALPIJA ZA HLADJENJE

  //calculateEnthalpy(+coolerTemperature, absoluteHumidity);
  //const massFlow = calculateMassFlow(prevPoint.airFlowHours);
  console.log(
    "calculateCoolerAbsHumidity" +
      calculateCoolerAbsHumidity(coolerTemperature, elevation)
  );
  console.log("enthaplu" + enthalpy);
  const airDensity = calculateAirDensity(
    airPressure,
    coolerTemperature,
    absoluteHumidity
  );

  //racuna se temperatura suvog termomentra u slucaju da je data snaga kao ulazni parametar
  let temperatureDryBulbCalculated;
  if (enthalpy === 0 && absoluteHumidity === 0)
    temperatureDryBulbCalculated = 0;

  let t1 =
    Math.round(
      ((enthalpy - (2501 * absoluteHumidity) / 1000) /
        (1.01 + (1.86 * absoluteHumidity) / 1000)) *
        10
    ) / 10;
  let t2 = -5.78132788671833;
  if (t1 > t2) temperatureDryBulbCalculated = t1;
  else temperatureDryBulbCalculated = t2;

  const relativeHumidity = Math.round(
    (((airPressure /
      1000 /
      calculatePD(
        P !== null ? temperatureDryBulbCalculated : +coolingTemperature
      )) *
      1000) /
      ((0.6222 / absoluteHumidity) * 1000 + 1)) *
      100
  );
  const realFlow = calculateRealFlow(massFlow, airDensity, absoluteHumidity);
  const usedPower = calculateUsedPower(massFlow, enthalpy, prevPoint.enthalpy);

  const usedWater = calculateUsedWater(
    massFlow,
    absoluteHumidity,
    prevPoint.absoluteHumidity
  );

  const temperatureWetBulbCalculated = calculateWetBulbTemperature(
    P !== null ? temperatureDryBulbCalculated : +coolingTemperature,
    relativeHumidity
  );

  /*let absoluteHumidityPower;
if (enthalpy ===0 && absoluteHumidity(M124)===0)
absoluteHumidityPower=0;
else{
  if (t1>t2)
  {
    =IF(AND(M$94<>"";M$95<>"");M$94;0)
    //formula iz stav 2 hladjenje
    //M$94 nastavak
    =IF(M33=1;IF(xchladice>=L18;L18;L18+(xchladice-L18)*(L19-M55)/(L19-Hchladice));IF(AND(M29=1;xchladice>=L18);L18;""))
    //M$95
    IF(M33=1;L19-ABS(M13/M35);IF(xchladice<L18;L19-(L19-Hchladice)*(M6-L16)/(Tchladice-L16);""))
    absoluteHumidity = M$94
    else absoluteHumidityPower=0
  }
  else {
    =0,6222*MaxVlhkost*M127/(Tlak_vzduchu-MaxVlhkost*M127/1000)
  }
  IF(M125>M126;M124;M128)
}*/

  return {
    temperatureDryBulbCalculated,
    temperatureWetBulbCalculated,
    absoluteHumidity,
    relativeHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    usedPower,
    usedWater,
  };
};

//Funkcija za racunanje parametara za tacku mesanja
export const calculateTableDataForMixing = (
  prevPoint,
  secondPrevPoint,
  elevation
) => {
  const absoluteHumidity = calculateAbsoluteHumidityMixing(
    prevPoint,
    secondPrevPoint
  );

  const enthalpy = calculateEnthalpyMixing(prevPoint, secondPrevPoint);

  const temperatureDryBulb =
    Math.round(
      ((enthalpy - (2501 * absoluteHumidity) / 1000) /
        (1.01 + (1.86 * absoluteHumidity) / 1000)) *
        10
    ) / 10;

  const massFlow = prevPoint.massFlow + secondPrevPoint.massFlow;

  const airPressure = calculateAirPressure(elevation);
  const airDensity = calculateAirDensity(
    airPressure,
    temperatureDryBulb,
    absoluteHumidity
  );
  const relativeHumidity = Math.round(
    (((+airPressure / 1000 / calculatePD(temperatureDryBulb)) * 1000) /
      ((0.6222 / absoluteHumidity) * 1000 + 1)) *
      100
  );
  const realFlow = calculateRealFlow(massFlow, airDensity, absoluteHumidity);

  //Kod tacke mesanja kolicina predate toplote je uvek nula
  const usedPower = 0;

  const usedWater = calculateUsedWaterMixing(
    massFlow,
    absoluteHumidity,
    prevPoint.massFlow,
    prevPoint.absoluteHumidity,
    secondPrevPoint.massFlow,
    secondPrevPoint.absoluteHumidity
  );
  const normalFlow = calculateNormalFlow(massFlow);
  const temperatureWetBulbCalculated = calculateWetBulbTemperature(
    temperatureDryBulb,
    relativeHumidity
  );

  return {
    temperatureDryBulb,
    temperatureWetBulbCalculated,
    relativeHumidity,
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    normalFlow,
    airDensity,
    usedPower,
    usedWater,
  };
};

//Funkcija za racunanje parametara za proces Parnog vlaženja
export const calculateTableDataForSteamHumidify = (
  newRelativeHumidity,
  elevation,
  prevPoint
) => {
  const temperatureDryBulb = prevPoint.temperatureDryBulb;
  //ubaciti maxVlaznost
  const airPressure = calculateAirPressure(elevation);
  //Za kalkulaciju je potrebma relativna vlaznost u decimalnim brojevima
  const decimalRelativeHumidity = +newRelativeHumidity / 100;
  const pd = calculatePD(temperatureDryBulb);
  const absoluteHumidity =
    (0.622 * decimalRelativeHumidity * pd) /
    (airPressure - (decimalRelativeHumidity * pd) / 1000);
  const relativeHumidity =
    (((airPressure / 1000 / pd) * 1000) /
      ((0.6222 / absoluteHumidity) * 1000 + 1)) *
    100;
  const enthalpy = calculateEnthalpy(temperatureDryBulb, absoluteHumidity);
  const airDensity = calculateAirDensity(
    airPressure,
    temperatureDryBulb,
    absoluteHumidity
  );

  const massFlow = prevPoint.massFlow;

  const realFlow = calculateRealFlow(massFlow, airDensity, absoluteHumidity);

  const usedPower = calculateUsedPower(massFlow, enthalpy, prevPoint.enthalpy);

  const usedWater = calculateUsedWater(
    massFlow,
    absoluteHumidity,
    prevPoint.absoluteHumidity
  );
  const normalFlow = calculateNormalFlow(massFlow);
  const temperatureWetBulbCalculated = calculateWetBulbTemperature(
    temperatureDryBulb,
    relativeHumidity
  );

  return {
    temperatureDryBulb,
    temperatureWetBulbCalculated,
    relativeHumidity,
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    normalFlow,
    airDensity,
    usedPower,
    usedWater,
  };
};
export function calculateDewPoint(temperatureDryBulb, relativeHumidity) {
  const temperatureDryBulb1 =
    temperatureDryBulb !== "" && temperatureDryBulb !== "-"
      ? parseFloat(temperatureDryBulb)
      : 0;
  const relativeHumidity1 =
    relativeHumidity !== "" && relativeHumidity !== "-"
      ? parseFloat(relativeHumidity)
      : 1;

  /*relativeHumidity = 100% x (E/Es)

where, according to an approximation of the Clausius-Clapeyron equation:

E =  0.611 * Math.exp(5423 * ((1/273) - (1/Td))] and

Es = 0.611 * Math.exp(5423 *((1/273) - (1/(+temperatureDryBulb + 273)))

where E0 = 0.611 kPa, (L/Rv) = 5423 K (in Kelvin, over a flat surface of water), T0 = 273 K (Kelvin)

and T is temperature (in Kelvin), and Td is dew point temperature (also in Kelvin)
*/
  /* let temperatureDewPoint =
    1 /
    (1 / (temperatureDryBulb + 273) -
      1 / 273 -
      Math.log(relativeHumidity) / 5423 +
      1 / 273);
  console.log(temperatureDewPoint);*/

  return (
    Math.round(
      ((243.04 *
        (Math.log(relativeHumidity1 / 100) +
          (17.625 * temperatureDryBulb1) / (243.04 + temperatureDryBulb1))) /
        (17.625 -
          (Math.log(relativeHumidity1 / 100) +
            (17.625 * temperatureDryBulb1) / (243.04 + temperatureDryBulb1)))) *
        100
    ) / 100
  );
}

export function saturation_pressure(t) {
  let pressure;
  var c1 = -5.6745359e3;
  var c2 = 6.3925247;
  var c3 = -9.677843e-3;
  var c4 = 6.2215701e-7;
  var c5 = 2.0747825e-9;
  var c6 = -9.484024e-13;
  var c7 = 4.1635019;

  var c8 = -5.8002206e3;
  var c9 = 1.3914993;
  var c10 = -4.8640239e-2;
  var c11 = 4.1764768e-5;
  var c12 = -1.4452093e-8;
  var c13 = 6.5459673;

  if (t > 0) {
    t = t + 273.15;
    pressure = Math.exp(
      c8 / t + c9 + c10 * t + c11 * t * t + c12 * t * t * t + c13 * Math.log(t)
    );
  } else {
    t = t + 273.15;
    pressure = Math.exp(
      c1 / t +
        c2 +
        c3 * t +
        c4 * t * t +
        c5 * t * t * t +
        c6 * t * t * t * t +
        c7 * Math.log(t)
    );
  }
  return pressure;
}
export function findpressure(altitude) {
  if (altitude < -5000 || altitude > 11000)
    alert("Altitude accurate from -5,000 to 11,000m");
  return 101325 * Math.pow(1 - 2.25577e-5 * altitude, 5.2559);
}

export function findHumidityRatio(
  temperatureDryBulb,
  relativeHumidity,
  altitude
) {
  let p_ws = saturation_pressure(temperatureDryBulb);
  let p_w = (p_ws * relativeHumidity) / 100;
  let pressure = findpressure(altitude);
  return Math.round(((0.621945 * p_w) / (pressure - p_w)) * 1000 * 100) / 100;
}

export default calcutationFunctions;

/*Here are some general guidelines:

The dry bulb temperature should be between -40°C and 50°C.
The wet bulb temperature should be between -10°C and 50°C.
The wet bulb temperature should be lower than the dry bulb temperature. If the wet bulb temperature is higher than the dry bulb temperature, it indicates a measurement error.
The difference between the dry bulb and wet bulb temperatures should be at least 0.5°C. If the difference is less than 0.5°C, it may not be possible to accurately calculate the dew point and humidity.*/
